import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { StatsArray } from '../types';
import YoutubeStatsGraph from './YoutubeStatsGraph/youtube-stats-graph';
import { Grid, customProperties as vars } from '@resi-media/resi-ui';
import { FillBlockSpinner, StatusCard } from '../../../components';
import { LOADER_SIZE_COMPONENT } from '../event-analytics-constants';

interface YoutubeAnalyticsViewProps {
  statsArray: StatsArray;
  isCardLoading: boolean;
}

const YoutubeAnalyticsView: FC<YoutubeAnalyticsViewProps> = ({ statsArray, isCardLoading }): JSX.Element => {
  return (
    <Grid display="grid" gridGap={vars.spacingXl} data-testid="analytics-page">
      <Grid.Item>
        <YoutubeStatsGraph />
      </Grid.Item>
      {isCardLoading ? (
        <FillBlockSpinner fontSize={LOADER_SIZE_COMPONENT} />
      ) : (
        <Grid display="grid" gridGap={vars.spacingXl} gridAutoColumns="1fr" gridTemplateColumns="repeat(4, 1fr)">
          {statsArray.map((item) => (
            <Grid.Item key={item.label}>
              <StatusCard
                label={item.label}
                change={item.change}
                count={item.count}
                isTrendUp={item.isTrendUp}
                data-testid="status-card"
              />
            </Grid.Item>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

YoutubeAnalyticsView.propTypes = {
  statsArray: PropTypes.array.isRequired,
};

YoutubeAnalyticsView.displayName = 'YoutubeAnalyticsView';

export default YoutubeAnalyticsView;
